import { withNamespaces } from "react-i18next"
import Accordion from 'react-bootstrap/Accordion';
import { Col, Row, Table, UncontrolledTooltip } from "reactstrap";
import { RiFileList3Line, RiInformationLine } from "react-icons/ri";

const CompanySummary = ({
    t,
    activeAccordion,
    setActiveAccordion,

    detailsQuery
}) => {
    if (detailsQuery.isFetching) {
        return (
            <Row>
                <Col 
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    const formatCurrency = (value, currency = "EUR") => {
        if (value == null) return "-";
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency,
        }).format(value);
    };

    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const companySummary = organizationData?.company_summary || {};

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('company-summary')}
            className={activeAccordion === 'company-summary' ? 'active' : ''}
            eventKey={'company-summary'}
        >
            <Accordion.Header>
                <RiFileList3Line size="24" className="me-2" />

                <span>
                    {t('Company Summary')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Row>
                    <Col lg="6">
                        <Table striped bordered hover size="sm">
                            <tbody>
                                <tr>
                                    <th
                                        style={{
                                            width: '40%'
                                        }}
                                    >{t('Business Name')}</th>
                                    <td>{companySummary.business_name || "-"}</td>
                                </tr>
                                <tr>
                                    <th>{t('Country')}</th>
                                    <td>{companySummary.country || "-"}</td>
                                </tr>
                                <tr>
                                    <th>{t('Company Number')}</th>
                                    <td>{companySummary.number || "-"}</td>
                                </tr>
                                <tr>
                                    <th>{t('Company Registration Number')}</th>
                                    <td>{companySummary.company_registration_number || "-"}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>

                    <Col lg="6">
                        <Table striped bordered hover size="sm">
                            <tbody>
                                <tr>
                                    <th
                                        style={{
                                            width: '40%'
                                        }}
                                    >{t('Company Status')}</th>
                                    <td>
                                        {companySummary.company_status?.status} - {companySummary.company_status?.description}
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Main Activity')}</th>
                                    <td>
                                        {companySummary.main_activity?.activity_description} (
                                        {companySummary.main_activity?.activity_code}, {companySummary.main_activity?.classification})
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Credit Rating')}</th>
                                    <td>
                                        {companySummary.credit_rating?.provider_value?.value} /{" "}
                                        {companySummary.credit_rating?.provider_value?.max_value} -{" "}
                                        {companySummary.credit_rating?.common_description} ({t('Limit')}:{" "}
                                        {formatCurrency(companySummary.credit_rating?.credit_limit)})
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        {t('Latest Turnover')}
                                        <span
                                            id="tooltip-latest-turnover"
                                            className="ms-1"
                                            style={{ cursor: "pointer" }}>
                                            <RiInformationLine />
                                        </span>
                                        <UncontrolledTooltip
                                            target="tooltip-latest-turnover"
                                        >
                                            {t('Latest value for the previous year’s Net Sales.')}
                                        </UncontrolledTooltip>
                                    </th>
                                    <td
                                        className="text-end"
                                    >
                                        {formatCurrency(companySummary.latest_turnover_figure)}
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        {t('Latest Shareholders Equity')}
                                        <span
                                            id="tooltip-latest-shareholders-equity"
                                            className="ms-1"
                                            style={{ cursor: "pointer" }}>
                                            <RiInformationLine />
                                        </span>
                                        <UncontrolledTooltip
                                            target="tooltip-latest-shareholders-equity"
                                        >
                                            {t('The total of Called up Share Capital, Revenue Reserves, Share Premium and Other Reserves.')}
                                        </UncontrolledTooltip>
                                    </th>
                                    <td
                                        className="text-end"
                                    >
                                        {formatCurrency(companySummary.latest_shareholders_equity_figure)}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    CompanySummary
)